import React from 'react';
import './App.css';
import Presentation from './pages/Presentation';

function App() {
  return (
    <div className="App">
      <Presentation />
    </div>
  );
}

export default App;
